import { getCookie, setJusbrasilCookie } from '@jusbrasil-web/shared-utils-cookies'
import { IncomingMessage } from 'http'

import { TemporaryOfferBannerDataProps, TemporaryOfferBannerProps } from './temporary-offer-banner'

export type TemporaryOfferBannerResult = TemporaryOfferBannerProps | null

const TEMPORARY_OFFER_BANNER_COOKIE_NAME = 'temporary_offer_banner'
const FIFTEEN_DAYS_IN_SECONDS = 60 * 60 * 24 * 15

export const isTemporaryOfferBannerCtaAlreadyClicked = (req: IncomingMessage): boolean =>
  getCookie<boolean>(req, TEMPORARY_OFFER_BANNER_COOKIE_NAME)

export type getTemporaryOfferBannerProps = {
  temporaryOfferBanner: TemporaryOfferBannerDataProps | null | undefined
  onCtaClick(): void
  onShow(): void
  onClose(): void
}

export const getTemporaryOfferBannerProps = ({
  temporaryOfferBanner,
  onCtaClick,
  onShow,
  onClose,
}: getTemporaryOfferBannerProps): TemporaryOfferBannerResult => {
  if (!temporaryOfferBanner) return null

  const handleCtaClick = () => {
    setJusbrasilCookie(null, TEMPORARY_OFFER_BANNER_COOKIE_NAME, 'true', {
      maxAge: FIFTEEN_DAYS_IN_SECONDS,
    })
    onCtaClick()
  }

  return {
    data: temporaryOfferBanner,
    onCtaClick: handleCtaClick,
    onShow,
    onClose,
  }
}
